import React from 'react'
import platform from '../../assets/images/mains/contact2.svg';

const ContactLanding = ({title}) => {
  return (
    <div className='hero-container container-sm'>
        <div className=' hero-row row m-0 w-100 h-100'>
            <div className='col-12 col-sm-6 heroText-container flex'>
                <div className='heroTitle w-100 mt-5'>
                      <h2 x-intersect="$el.classList.add('fadeInUp-parallax')">{title}</h2>
                </div>
                <div className='heroDesc w-100 my-4'>
                    <p x-intersect="$el.classList.add('fadeInUp-parallax')">We would love to help you boost your business's conversion!</p>
                </div>
            </div>
            <div className='col-12 col-sm-6 mt-5 mt-sm-0'>
                <div className='hero-img-container'>
                    <img className='img-fluid contactForm-heoImg' src={platform} alt="platform" x-intersect="$el.classList.add('scale-parallax')"/>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ContactLanding